export const ID_OTHER_UFC_DELEGATE = '0';
